"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const caretdown = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-caretdown` : '') + (description ? ` desc-caretdown` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-caretdown"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-caretdown"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.999 15.825L2.34719 6.51432L2.25648 6.43792C1.87261 6.16234 1.35675 6.19695 1.02776 6.51437C0.65739 6.87171 0.657418 7.45489 1.02782 7.81219L10.8545 17.2914L10.9641 17.3877C11.2631 17.6246 11.6257 17.75 12 17.75C12.4293 17.75 12.8414 17.5851 13.146 17.2909L22.9722 7.81219L23.0515 7.7246C23.3425 7.34735 23.3057 6.83611 22.9722 6.51437L22.8671 6.42678C22.4977 6.16236 21.9818 6.19692 21.6528 6.51431L11.999 15.825Z",
    fill: "inherit"
  }));
};
var _default = exports.default = caretdown;